import _ from "lodash";
import ExternalLogger from "core-ui/client/src/app/ExternalLogger";
import noContactInfoModalTemplate from "./noContactInfoModalTemplate";
import oneIdEvents from "./events/OneIdEvents";

var LinkablePlansSelectionController = function (
	$modal,
	$rootScope,
	$scope,
	$state,
	LinkablePlansFactory,
	eventBus,
	redirectService
) {
	var vm = this;
	vm.selectedIndId = [];
	vm.selectedIndidsForLinking = [];
	vm.error = false;
	vm.modalInstance;
	var logger = ExternalLogger.getInstance('LinkablePlansSelectionController');
	vm.init = function () {
		vm.loading = true;

		if ($state.current.name === 'linkablePlansProfile') {

			LinkablePlansFactory.retrievePlansAvailableForLinkingForProfile.query({}, 
				function (data) {
					$rootScope.plansMapWithIndIdDbName = data.linkablePlansMap;
					$scope.previousSelectedVal = 'none';
					$scope.currentUserPlans = data.currentUserPlans;
					vm.setCheckedAttributeBasedOnMFAFinishedAttribute();
				},
				function (error) {
					console.log('LinkablePlansFactory.retrievePlansAvailableForLinkingForProfile - ERROR: ', error);
					logger.error(error)
				}
			);
		} else {
			LinkablePlansFactory.retrievePlansAvailableForLinking.query({},
				function (data) {
					$rootScope.plansMapWithIndIdDbName = data.linkablePlansMap;
					$scope.previousSelectedVal = 'none';
					$scope.currentUserPlans = data.currentUserPlans;
					vm.setCheckedAttributeBasedOnMFAFinishedAttribute();
				},
				function (error) {
					console.log('LinkablePlansFactory.retrievePlansAvailableForLinking - ERROR: ', error);
					logger.error(error)
				}
			);
		}

		vm.togglePlanSelection = function (key) {
			$rootScope.linkingContext = key;
			var keeplooking = true;
			// eslint-disable-next-line no-undef
			angular.forEach($rootScope.plansMapWithIndIdDbName, function (values, tempKey) {
				if (key === tempKey && keeplooking) {
					// eslint-disable-next-line no-undef
					angular.forEach(values, function (value) {
						var contactThere = value.contactsThere;
						var mfaFinished = value.mfaFinished;
						if (!contactThere && keeplooking) {
							vm.phoneNum = $rootScope.siteContactInfo.phone;
							$rootScope.plansMapWithIndIdDbName[key].checked = false;
							vm.openNoContactInfoModal();
							value.checked = false;
							keeplooking = false;
						}
						else if (contactThere && !mfaFinished) {
							$state.go('oneIdMfaActivationCode');
							keeplooking = false;
						}
						else if (contactThere && mfaFinished) {
							$state.go('linkablePlans');
							keeplooking = false;
						}
					});
				}
			});
		};
		vm.loading = false;
	};

	vm.dataForNoContactInfoModal = function () {
		var plansFromCurrentContext = [];
		// eslint-disable-next-line no-undef
		angular.forEach($rootScope.plansMapWithIndIdDbName, function (values, key) {
			if (key === $rootScope.linkingContext) {
				// eslint-disable-next-line no-undef
				angular.forEach(values, function (value) {
					plansFromCurrentContext.push(value)

				});
			}

		});
		$rootScope.plansFromCurrentContext = plansFromCurrentContext;

	}

	vm.isMFAFnishedPrior = function (key) {
		var mfaFinishedPrior = false;
		eventBus.dispatch(oneIdEvents.IS_MFA_NEEDED, this);
		vm.loading = true;
		var temp = [];

		temp = key.split(":");
		var params = {
			"indId": temp[0], "dbName": temp[1]
		};

		LinkablePlansFactory.isMfaFinishedPrior.query(params,
			//success
			function (data, headers) {
				mfaFinishedPrior = data.data
				vm.loading = false;

			},
			function (response) {
				vm.loading = false;
				vm.error = true;

			}
		);
		return mfaFinishedPrior;
	};

	vm.cancelModal = function () {
		$rootScope.modalInstanceWithNoContact.dismiss('cancel');
	};

	vm.openNoContactInfoModal = function () {

		$rootScope.modalInstanceWithNoContact = $modal.open({
			template: noContactInfoModalTemplate,
			controller: vm,
			controllerAs: 'LinkablePlansSelectionController',
			size: 'md',
			windowClass: 'modal-wrapper'
		});
	};

	vm.checkIfLockNeeded = function (keyToCompare) {
		var lockNeeded = true;
		var keeplooking = true;

		// eslint-disable-next-line no-undef
		angular.forEach($rootScope.plansMapWithIndIdDbName, function (values, key) {
			if (keeplooking && keyToCompare === key) {
				lockNeeded = !values[0].mfaFinished
				keeplooking = false;
			}
		});

		return lockNeeded;
	}

	vm.checkForEnabling = () => {
		return _.find($rootScope.plansMapWithIndIdDbName, account => account[0].checked === false) === undefined;
	}

	vm.setCheckedAttributeBasedOnMFAFinishedAttribute = function () {
		// eslint-disable-next-line no-undef
		angular.forEach($rootScope.plansMapWithIndIdDbName, function (values, key) {
			// eslint-disable-next-line no-undef
			angular.forEach(values, function (value) {
				value.checked = value.mfaFinished;
			});
		});
	}

	vm.continueClick = function (name) {
		vm.loading = true;
		var selectedIndidsForLinking = [];
		eventBus.dispatch(oneIdEvents.CONTINUE_LINKING, this);

		// eslint-disable-next-line no-undef
		angular.forEach($rootScope.plansMapWithIndIdDbName, function (value, key) {
			// eslint-disable-next-line no-undef
			angular.forEach(value, function (planValue) {
				if (planValue.checked && planValue.checked === true) {
					if (selectedIndidsForLinking.indexOf(key) == -1) {
						selectedIndidsForLinking.push(key);
					}
				}
			});
		});

		vm.selectedIndidsForLinking = selectedIndidsForLinking;

		if (vm.selectedIndidsForLinking.length > 0) {
			LinkablePlansFactory.linkAccounts.query(vm.selectedIndidsForLinking,
				//success
				function (data) {
					vm.loading = false;
					redirectService.redirect(data.data, 'ALL');
				},
				function (error) {
					vm.loading = false;
					vm.error = true;
					console.error('LinkablePlansFactory.linkAccounts - ERROR: ', error);
				}
			);
		}

	};
	vm.init();
};

LinkablePlansSelectionController.$inject = [
	'$modal',
	'$rootScope',
	'$scope',
	'$state',
	'LinkablePlansFactory',
	'eventBus',
	'redirectService'
];
export default LinkablePlansSelectionController;
